// *** ROLE SERVICE ***

// GLOBAL ROLE VARIABLES
export const PHARMACY_OWNER = 'pharmacy_owner';
export const PHARMACIST = 'pharmacist';
export const SUPERADMIN = 'superadmin';
export const TECHNICIAN = 'technician';

// GLOBAL PERMISSION VARIABLE
export const permissions = [
    'create_pharmacy',
    'create_user',
    'edit_pharmacy',
    'edit_user',
    'show_pharmacy',
    'show_user',
    'superadmin'
];
